import React from 'react';
import ReactDOM from 'react-dom';
import { withLock, keyVault } from '@bingads-webui-react/popup-manager';
import { AuctionInsightPopup } from './auction-insight-popup';
import { instrumentationSchema } from './instrumentation-schema';

export function createAuctionInsightPopupFactory(props, placeholderElement) {
  const {
    onDismiss,
    instrumentation,
    context,
  } = props;

  instrumentation.addScenario(instrumentationSchema);
  const auctionInsightScenario = instrumentation.auctionInsight.create();
  const userActionActivity = auctionInsightScenario.userAction.create();

  const onOutsideClick = (e, srcTarget) => {
    if (e.target !== srcTarget) {
      /* istanbul ignore next */
      if (onDismiss) {
        onDismiss();
      }
      userActionActivity
        .trace(
          `Insight popup closed. cid: ${context.CurrentCustomer.Id}, uid: ${context.CurrentUser.Id}, isInternal: ${context.CurrentUser.IsInternal ? 'true' : 'false'}`,
          'AuctionInsightAction'
        );
      ReactDOM.unmountComponentAtNode(placeholderElement);
    }
  };

  userActionActivity
    .trace(
      `Insight popup opened. cid: ${context.CurrentCustomer.Id}, uid: ${context.CurrentUser.Id}, isInternal: ${context.CurrentUser.IsInternal ? 'true' : 'false'}`,
      'AuctionInsightAction'
    );

  const AuctionInsightPopupWithLock = withLock(AuctionInsightPopup, {
    lockKey: keyVault.clickingPopup,
    force: true,
  });

  ReactDOM.render(
    React.createElement(AuctionInsightPopupWithLock, {
      ...props,
      onDismiss: onOutsideClick,
    }),
    placeholderElement
  );
}
